import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConditionalApprove = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 10,
		cy: 10.916,
		r: 10,
		fill: "#f4a107"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.8911 7.99805L8.54384 13.3453L6.11328 10.9147",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgConditionalApprove;
